import { render, staticRenderFns } from "./qcteam_text.vue?vue&type=template&id=61640482&scoped=true"
import script from "./qcteam_text.vue?vue&type=script&lang=js"
export * from "./qcteam_text.vue?vue&type=script&lang=js"
import style0 from "./qcteam_text.vue?vue&type=style&index=0&id=61640482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61640482",
  null
  
)

export default component.exports